var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49,4h12.5v-2H7.49c-.96,0-1.78.34-2.47,1.03-.68.68-1.03,1.5-1.03,2.47v13c0,.97.35,1.79,1.03,2.48.69.68,1.51,1.02,2.47,1.02h12.5V7H7.49c-.42,0-.78-.14-1.07-.44-.28-.29-.43-.64-.43-1.06s.15-.79.43-1.07c.29-.29.65-.43,1.07-.43ZM9.22,14.6h1.78v-3c0-.55.46-1,1-1s1,.45,1,1v3h1.79c.45,0,.68.54.36.86l-2.8,2.79c-.19.2-.5.2-.7,0l-2.8-2.79c-.31-.32-.08-.86.37-.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBook);
export default __webpack_public_path__ + "static/media/download-book.9a41b8bfa253ecd38e3dc09703316243.svg";
export { ForwardRef as ReactComponent };